import { createSelector } from 'reselect';
import { RootState } from '../../store';

const selectHmiState =  (state: RootState) => state.hmiState;

export const selectAllHmiScheme = createSelector(
    selectHmiState,
    (hmiState) => hmiState.schemas,
);
